// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewBoardImage_modal-scroll__xE68V","article-image":"ViewBoardImage_article-image__VAHoc","empty":"ViewBoardImage_empty__d_F_h"};